import type { FC } from 'react';
import React, { useMemo, useState } from 'react';

import { useBoolean } from '@sravni/react-utils';

import { Table } from '@components/RatingTable/components/Table/Table';
import { makeConfig } from '@components/RatingTable/config';

import { RATING_TYPES } from '../../constants/filters';
import { useFilters } from '../../store/hooks/filters';
import { useProductConfig } from '../../store/hooks/productPopupInfo';
import type { OrganizationRatingItem } from '../../types/rating';

import { ProductPopup } from './components/ProductPopup/ProductPopup';

type RatingTableProps = {
  rating: OrganizationRatingItem[];
};

export const RatingTable: FC<RatingTableProps> = ({ rating }) => {
  const filters = useFilters();
  const [product, setProduct] = useState(null);
  const [isProductPopupVisible, setProductPopupVisibility] = useBoolean(false);

  const { ratingType } = filters;

  const productConfig = useProductConfig();
  const canShowProductPopup = ratingType === RATING_TYPES.Products && Boolean(productConfig);

  const tableConfig = useMemo(() => makeConfig(rating, filters), [filters, rating]);

  const handleClosePopup = () => {
    setProductPopupVisibility.off();
  };

  return (
    <>
      <Table
        config={tableConfig}
        setProduct={setProduct}
        setProductPopupVisibility={setProductPopupVisibility}
        canShowProductPopup={canShowProductPopup}
      />
      {canShowProductPopup && Boolean(product) && (
        <ProductPopup isVisible={isProductPopupVisible} onClose={handleClosePopup} product={product} />
      )}
    </>
  );
};
